import { initEsimPriceList } from './components/price-list'
import { initEsimDevices } from './components/devices'
import initQrPopup from 'components/qr-popup'
import { initFAQ } from 'components/faq'

const $priceListRoot = document.querySelector<HTMLElement>('[data-js="esim-price-list"]')
if ($priceListRoot) {
  initEsimPriceList($priceListRoot)
}

const $devicesRoot = document.querySelector<HTMLElement>('[data-js="esim-devices"]')
if ($devicesRoot) {
  initEsimDevices($devicesRoot)
}

initQrPopup()
initFAQ()
